module.exports = __webpack_public_path__ + "0d4542e8aa87c73ad428cb832b5fcd9d.jpg";